import { CurrencyEuroIcon } from "@heroicons/react/20/solid";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { XCircleIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import { endOfMonth, startOfMonth, subMonths } from "date-fns";
import type { ReactNode } from "react";

import { invoiceStatusId } from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import type { InvoiceStatusId } from "~/modules/billing/api/processedInvoice/processedInvoiceTypes.ts";
import type {
	InvoicesIndexDefaultPageState,
} from "~/modules/billing/components/InvoicesIndexView/InvoicesIndexTableTypes.ts";
import { formatDateToYYYYMMDD } from "~/utils/dateAndTimeUtils.ts";

const now = new Date();
const defaultStartDate = formatDateToYYYYMMDD(startOfMonth(subMonths(now, 2)));
const defaultEndDate = formatDateToYYYYMMDD(endOfMonth(now));

export const defaultInvoicesIndexDeliveryPeriodFilterDateRange = {
	startDate: defaultStartDate,
	endDate: defaultEndDate,
};

export const invoicesIndexDefaultPageState: InvoicesIndexDefaultPageState = {
	columnFilters: [
		{ id: "invoiceStatusId", value: [] },
		{ id: "companyShortName", value: [] },
	],
	deliveryPeriodFilter: defaultInvoicesIndexDeliveryPeriodFilterDateRange,
	globalFilter: "",
	sorting: [{ id: "deliveryStartDate", desc: true }],
};

export const getInvoiceStatusIcon = (statusId: InvoiceStatusId, className?: string, isOverdue?: boolean): ReactNode => {
	switch (statusId) {
		case invoiceStatusId.Draft:
		case invoiceStatusId.AwaitingApproval:
		case invoiceStatusId.Approved:
			return <PencilSquareIcon className={clsx(" text-primary-300", className)} />;
		case invoiceStatusId.SentToClient:
			return <><CurrencyEuroIcon className={clsx(" text-yellow-500", className)} />{isOverdue &&
				<span className="text-base	 font-bold text-danger-500">!</span>}</>;
		case invoiceStatusId.Paid:
			return <CurrencyEuroIcon className={clsx(" text-success-500", className)} />;
		case invoiceStatusId.Reversed:
			return <XCircleIcon className={clsx("text-danger-500", className)} />;
		default:
			return null;
	}
};